import axios from 'axios'
import { toSnakeCase, toCamelCase } from '../utils'


const instance = axios.create()

instance.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    return config
  }
  config.data = toSnakeCase(config.data)
  return config
}, function (error) {
  return Promise.reject(toSnakeCase(error))
})

instance.interceptors.response.use((response) => {
  return toCamelCase(response)
}, function (error) {
  return Promise.reject(toCamelCase(error))
})

export default instance